module.exports = __webpack_public_path__ + "img/fenouil.1d97d2b3.jpeg";